<template>
  <div>
    <v-navigation-drawer v-if="showDrawer"
                         width="300px"
                         style="z-index: 100 !important"
                         :absolute="!isAppLayout"
                         :temporary="isTemporary"
                         :app="isAppLayout"
                         :value="showDrawer"
                         @transitionend="handleTransitionEnd"
    >
      <component :is="navDrawerComponent"/>
    </v-navigation-drawer>
    <layer-control color="white" :y-offset="lcOffset" :x-offset="8"
                   :float="floatLayerControl"
                   v-if="showDedicatedLayerControl && !$vuetify.breakpoint.mobile"></layer-control>
  </div>

</template>

<script>
import { mapState, mapGetters } from 'vuex';
import LayerControl from './LayerControl';
import infoQuery from './infoQuery';

export default {
  name: 'TheSidebar',

  components: {
    LayerControl,
    infoQuery
  },

  methods: {
    handleTransitionEnd() {
      //Clears the feature info query when user clicks the temp overlay
      this.$store.commit('featureInfo/CLEAR_QUERY');
    }
  },

  computed: {
    ...mapState('featureInfo', {
      QUERY_RESULTS: 'results'
    }),
    ...mapGetters({
      TOOLS: 'TOOLS',
      CONFIG: 'CONFIG'
    }),
    lcOffset() {
      return this.CONFIG.config.showTitle ? 135 : 90;
    },
    isAppLayout() {
      return this.TOOLS.indexOf('layerControl') > -1 && !this.CONFIG.config.layerControlFloat;
    },
    isTemporary() {
      if (!this.CONFIG) return false
      if (this.CONFIG.config.layerControlFloat && !this.CONFIG.config.infoPopup && this.QUERY_RESULTS.length !== 0) {
        return true;
      }
      if (!this.CONFIG.config.layerControlFloat && this.TOOLS.indexOf('layerControl') < 0) {
        return true;
      }

      return false;
    },
    navDrawerComponent() {
      if (this.QUERY_RESULTS.length && !this.CONFIG.config.infoPopup) {
        return 'info-query';
      } else if (this.TOOLS.indexOf('layerControl') > -1 && !this.CONFIG.config.layerControlFloat) {
        return 'layer-control';
      }

      return '';
    },
    floatLayerControl(){
      return !!this.CONFIG.config.layerControlFloat
    },
    showDedicatedLayerControl() {
      let retVal = false;

      if (this.TOOLS.indexOf('layerControl') > -1) { //if layer control enabled
        if (this.CONFIG.config.layerControlFloat && this.CONFIG.config.infoPopup) {
          //if popup is enabled, we always show layer control
          retVal = true;
        } else if (this.CONFIG.config.layerControlFloat && !this.CONFIG.config.infoPopup && this.QUERY_RESULTS.length === 0) {
          //if not using popup, only show it when there are no query results
          retVal = true;
        }
      }
      return retVal;
    },
    showDrawer() {
      return (
          //layer control enabled and NOT floating
          this.TOOLS.indexOf('layerControl') > -1 &&
          !this.CONFIG.config.layerControlFloat &&
          !this.$vuetify.breakpoint.mobile
        )
        //has query results and NOT popup
        || this.QUERY_RESULTS.length > 0 && !this.CONFIG.config.infoPopup;
    }
  },

  data() {
    return {};
  }
};
</script>

<style scoped>

</style>
